export default __webpack_public_path__ + "static/media/logo.587a402d.png";